import { Game } from './game/game';
import { logger } from './game/logger';

// Create debug overlay (hidden by default, toggled via LOG button)
logger.initOverlay();

// Global error handlers — catch anything the game loop misses
window.addEventListener('error', (e) => {
  logger.error('Uncaught error', e.error ?? e.message);
});
window.addEventListener('unhandledrejection', (e) => {
  logger.error('Unhandled promise rejection', e.reason);
});

const wrapper = document.getElementById('game-wrapper');
if (!wrapper) {
  throw new Error('Game wrapper element #game-wrapper not found');
}

const game = new Game(wrapper);
game.start().catch((err) => {
  logger.error('Failed to start game', err);
});
